<template>
  <div class="fillcontain">
    <search-item
      @searchList="getBeginCourseList"
      @changePageAndLimit="handleChangePageAndLimit"
    ></search-item>

    <!-- <search-item
      @searchList="getBeginCourseList"
    ></search-item>-->

    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
        @expand-change="toggleRowData"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
      >
        <!-- <el-table-column prop="id" label="序号" align="center"></el-table-column> -->
        <!-- <el-table-column type="selection" align="left"></el-table-column> -->
        <el-table-column type="expand">
      <template>
        <el-table :data="expandsStudent" style="width: 100%">
           <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="约课编号"
            prop="id">
          </el-table-column>
          <el-table-column
            label="学员姓名"
            prop="stdName">
          </el-table-column>
          <el-table-column
            label="家长姓名"
            prop="parentName">
          </el-table-column>
           <el-table-column
            label="电话"
            prop="telephone">
          </el-table-column>
          <el-table-column
            label="生日"
            prop="stdBrith">
            <template slot-scope="scope">
              {{scope.row.stdBrith.split(' ')[0]}}
            </template>
          </el-table-column>
          <el-table-column
            label="年龄"
            prop="stdBrith">
            <template slot-scope="scope">
              {{scope.row.stdBrith | calcStudentAge}}岁
            </template>
          </el-table-column>
          <el-table-column
            label="课包"
            prop="packageName">
          </el-table-column>
          <el-table-column
           label="主教练评价"
           prop="coursePerformance">
         </el-table-column>
          <el-table-column
           label="助教评价"
           prop="assRate1">
         </el-table-column>
          <el-table-column
           label="助教评价"
           prop="assRate2">
         </el-table-column>
          <el-table-column
           label="备注"
           prop="recordNote">
         </el-table-column>
          <el-table-column
            label="学习内容"
            prop="courseContent">
          </el-table-column>
          <el-table-column
            label="操作"
            prop="recordNote">
            <template slot-scope="scope">
               <el-button
              type="primary"
              icon="edit"
              size="mini"
              @click="onStudentEdit(scope.row)"
              >编辑</el-button>
               <el-button
              type="danger"
              icon="edit"
              size="mini"
              @click="delAppointment(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="会员类型"
            prop="memberType">
            <template slot-scope="scope">
            <el-tag
              :type="scope.row.memberType === 0 ? 'warning' : 'success'"
              disable-transitions
              >{{ scope.row.memberType }}</el-tag>
          </template>
          </el-table-column>
          <el-table-column
            label="会员状态"
            prop="memberStatus">
            <template slot-scope="scope">
            <el-tag
              :type="scope.row.memberStatus === 0 ? 'danger' : 'success'"
              disable-transitions
              >{{ scope.row.memberStatus }}</el-tag
            >
          </template>
          </el-table-column>
          <el-table-column
            label="注册时间"
            prop="memberRegisterDate">
            <template slot-scope="scope">
            {{scope.row.memberRegisterDate.split(' ')[0]}}
          </template>
          </el-table-column>
          <el-table-column
            label="最后约课时间"
            prop="lastAppointmentTime">
          </el-table-column>
          <el-table-column
            label="备注"
            prop="memberNote">
          </el-table-column> -->
        </el-table>
      </template>
    </el-table-column>
        <el-table-column
          width="150"
          prop="courseDate"
          label="日期"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{
              scope.row.courseDate | filterTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="courseTime"
          width="150"
          label="课程时间段"
          align="left"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag disable-transitions>{{ scope.row.courseTime }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="classType"
          label="班级类型"
          align="left"
          :filters="this.courseTypeData"
          :filter-method="filterCourseType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseType(scope.row)"
              disable-transitions
              >{{ scope.row.classType }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="courseLocation"
          width="150"
          label="课程地点"
          align="left"
          :filters="this.courseLocationData"
          :filter-method="filterCourseLocation"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseLocation(scope.row)"
              disable-transitions
              >{{ scope.row.courseLocation }}</el-tag
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="coursePackages"
          label="课包类型"
          align="left"
          :filters="this.coursePackagesData"
          :filter-method="filterCoursePackages"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCoursePackages(scope.row)"
              disable-transitions
            >{{scope.row.coursePackages}}</el-tag>
          </template>
        </el-table-column>-->
        <!-- <el-table-column
          prop="coursePackages"
          label="课包类型"
          align="left"
        ></el-table-column> -->
        <el-table-column
          width="70"
          prop="coursePeopleCounts"
          label="学员人数"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="coaches"
          label="教练"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="courseNote"
          label="备注"
          align="left"
        ></el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <!-- <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onGoToDetail(scope.row)"
              >详情</el-button
            > -->
            <el-button
              type="primary"
              size="mini"
              @click="onOpenDeleteRecord(scope.row)"
              >删除记录</el-button
            >
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onOpenAddStudent(scope.row)"
              >添加</el-button
            >
            <el-button
              type="primary"
              icon="edit"
              size="mini"
              @click="onEditFinishedCourse(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="edit"
              size="mini"
              @click="onEditCoach(scope.row)"
              >打卡</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="修改备注" :visible.sync="clockInDialogShow">
        <div class="form">
          <el-form
            ref="form"
            :model="form"
            :label-width="dialog.formLabelWidth"
            style="margin: 10px; width: auto"
          >
            <el-form-item required prop="courseNote" label="课程备注:">
              <el-input type="text" v-model="form.courseNote"></el-input>
            </el-form-item>

            <el-form-item class="text_right">
              <el-button @click="clockInDialogShow = false">取 消</el-button>
              <el-button type="primary" @click="onSubmit('form')"
                >提 交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-dialog title="删除约课记录" :visible.sync="clockInDialogShow9">
        <el-form ref="appointmentRecordDate" :model="appointmentRecordDate">
          <el-form-item required label="删除原因" :label-width="formLabelWidth">
            <el-input
                    placeholder="请输入删除原因"
                    :rows="2"
                    type="text"
                    v-model="appointmentRecordDate.remark"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clockInDialogShow9 = false">取 消</el-button>
          <el-button type="primary" @click="onDelAppointment()"
          >确 定</el-button
          >
        </div>
      </el-dialog>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <el-dialog title="教练打卡" :visible.sync="clockInDialogShow1">
        <el-form ref="coachform" :model="coachform">
          <el-form-item label="教练名称" :label-width="formLabelWidth">
            <el-select
              v-model="coachform.coachId"
              multiple
              collapse-tags
              style="margin-left: 20px"
              placeholder="请选择教练名称"
              @change="changevalue"
            >
              <el-option
                v-for="item in coachList"
                :key="item.coachName"
                :label="item.coachName"
                :value="item.coachId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clockInDialogShow1 = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit1('coachform')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <el-dialog title="添加学生" :visible.sync="appointmentVisible">
        <el-form ref="appointmentCourseDate" :model="appointmentData">
          <el-form-item required label="学生姓名" :label-width="formLabelWidth">
            <el-input
              placeholder="请输入学生姓名"
              :rows="2"
              type="text"
              v-model="appointmentData.studentName"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="会员手机号"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入会员手机号"
              :rows="2"
              type="text"
              v-model="appointmentData.phone"
              @input="searchCourse"
            ></el-input>
          </el-form-item>
          <el-form-item required label="是否候补" :label-width="formLabelWidth">
            <el-select
              v-model="appointmentData.isCandidate"
              placeholder="请选择是否候补"
            >
              <el-option
                v-for="item in candidateList"
                :label="item.label"
                :key="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item required label="课包类型">
            <el-cascader
              v-model="appointmentCourseDate.coursePackageId"
              :options="options"
              collapse-tags
              :show-all-levels="false"
              @change="changeVal"
              clearable
            ></el-cascader>
          </el-form-item> -->
          <el-form-item required label="会员课包" :label-width="formLabelWidth">
            <el-select
              v-model="appointmentData.coursepackageid"
              placeholder="请选择"
              style="width:300px"
            >
              <el-option
                v-for="item in this.coursePackageAndMemberOption"
                :key="item.id"
                :label="item.coursePackageName ? (item.coursePackageName + ' （剩余课时数：' + item.classHour) + ')': ''"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="appointmentVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitStudent"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog title="预约课程" :visible.sync="studentVisible">
        <el-form ref="studentCourseDate" :model="studentData">
          <el-form-item label="主教练评价" :label-width="formLabelWidth">
            <el-input
              placeholder="请输入主教练评价"
              :rows="2"
              type="text"
              v-model="studentData.coursePerformance"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="助教评价"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入助教评价"
              :rows="2"
              type="text"
              v-model="studentData.assRate1"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="助教评价"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入助教评价"
              :rows="2"
              type="text"
              v-model="studentData.assRate2"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="备注"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入备注"
              :rows="2"
              type="text"
              v-model="studentData.recordNote"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="学习内容"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入学习内容"
              :rows="2"
              type="text"
              v-model="studentData.courseContent"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="studentVisible = false">取 消</el-button>
          <el-button type="primary" @click="eidtStudent"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog title="删除记录列表" :visible.sync="deleteRecordVisible">
        <el-table :data="deleteRecordList" style="width: 100%">
           <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            label="约课编号"
            prop="id">
          </el-table-column>
          <el-table-column
            label="学员姓名"
            prop="stdName">
          </el-table-column>
          <el-table-column
            label="家长姓名"
            prop="parentName">
          </el-table-column>
           <el-table-column
            label="电话"
            prop="telephone">
          </el-table-column>
          <el-table-column
            label="生日"
            prop="stdBrith">
            <template slot-scope="scope">
              {{scope.row.stdBrith.split(' ')[0]}}
            </template>
          </el-table-column>
          <el-table-column
            label="年龄"
            prop="stdBrith">
            <template slot-scope="scope">
              {{scope.row.stdBrith | calcStudentAge}}岁
            </template>
          </el-table-column>
          <el-table-column
            label="课包"
            prop="packageName">
          </el-table-column>
          <el-table-column
            label="课堂表现"
            prop="coursePerformance">
          </el-table-column>
          <el-table-column
            label="课堂备注"
            prop="recordNote">
          </el-table-column>
          <el-table-column
            label="学习内容"
            prop="courseContent">
          </el-table-column>
          <el-table-column
            label="删除原因"
            prop="courseContent">
          </el-table-column>
        </el-table>
        <pagination
          :pageTotal="pageTotalDelete"
          @handleCurrentChange="handleCurrentChangeDelete"
          @handleSizeChange="handleSizeChangeDelete"
        ></pagination>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteRecordVisible = false">关 闭</el-button>
          <!-- <el-button type="primary" @click="submitStudent">确 定</el-button> -->
        </div>
      </el-dialog>
  
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
// import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getFormatClassTypes } from "@/api/courseType";
import { getFormatCoaches } from "@/api/coach";
import { updateRecord } from "@/api/record";

import {
  getFinishedCourseLists,
  getCourseCoachLists,
  editFinishedCourse,
  getCoursePackagesByCourseId,
  getCourseByMemberLists,
  deleteRecord,
  addAppointmentCourseByPhone,
  getCoursePackageAndMemberByPhone,
  getCourseExtByMemberLists
} from "@/api/course";
import {
  getCoachLists,
  getCoachListsByCourseId,
  courseBlindCoach,
} from "@/api/coach";
import { getFormatTeachingpoint } from "@/api/teachingpoint";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      courseData: {},
      tableData: [],
      courseTypeData: [],
      courseLocationData: [],
      coursePackagesData: [],
      tableHeight: 0,
      loading: false,
      formLabelWidth: "120px",
      coachList: [],
      clockInDialogShow: false,
      clockInDialogShow1: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      multipleSelection: [], //多选的数据
      sortnum: 0,
      format_course_type_list: {},
      format_course_location_list: {},
      format_course_packages_list: {},
      appointmentRecordDate: {
        remark: "",
        id: "",
      },
      clockInDialogShow9: false,
      course_id: "",
      courseData: {
        page: 1,
        limit: 20,
      },
      //教练信息
      coachform: {
        coachId: [],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      form: {
        id: "",
        courseNote: "",
      },
      //表格展开行
      expands: [],
      expandsStudent:[],
      currentExpandRow:{},
      getRowKeys(row) {
         return row.id
      },
      //6.24
      courseRow: {},
      appointmentVisible: false,
      appointmentData:{},
      candidateList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      coursePackageAndMemberOption: [
        {
          value: "-1",
          label: "该会员没有这种类型的课包",
        },
      ],
      studentData:{
        id: "",
        coursePerformance: "",
        assRate1: "",
        assRate2: "",
        recordNote: "",
        courseContent: ""
      },
      studentVisible: false,
      phoneTimer: null,
      //删除记录弹框表格部分
      deleteRecordVisible: false,
      deleteRecordRow: {},
      deleteRecordForm:{
        page: 1,
        limit: 20,
      },
      pageTotalDelete: 0,
      deleteRecordList: []
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
    calcStudentAge(startDate) {
      var date = new Date();
      startDate = new Date(startDate);
      var newDate = date.getTime() - startDate.getTime();
      // 向下取整  例如 10岁 20天 会计算成 10岁
      // 如果要向上取整 计算成11岁，把floor替换成 ceil
      return Math.floor(newDate / 1000 / 60 / 60 / 24 / 365);
    },
  },
  components: {
    SearchItem,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch", "beginCourseSearchData"]),
  },
  mounted() {
    this.getFormatClassTypes();
    this.getFormatTeachingpoint();
    this.getBeginCourseList();
    this.getFormatCoaches();
  },
  methods: {
    handleChangePageAndLimit() {
      this.courseData.page = 1;
      this.courseData.limit = 20;
    },
    changevalue(value) {
      // console.log(value);
      // console.log(this.coachform.coachId);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    getFormatCoaches() {
      getFormatCoaches().then((res) => {
        console.log(res);
        this.coachList = res.data.data.coaches;
      });
    },
    getFormatTeachingpoint() {
      getFormatTeachingpoint().then((res) => {
        console.log(res);
        this.courseLocationData = res.data.data.courseLocationData;
        this.format_course_location_list =
          res.data.data.formatCourseLocationList;
      });
    },
    getFormatClassTypes() {
      getFormatClassTypes().then((res) => {
        console.log(res);
        this.courseTypeData = res.data.data.classTypeDataList;
        this.format_course_type_list = res.data.data.formatClassTypeList;
      });
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取教练列表
    getCoachList() {
      const para = {
        page: 1,
        limit: 100,
        coachName: "",
      };
      getCoachLists(para).then((res) => {
        // console.log(res);
        this.$store.commit("SET_COACH_LIST", res.data.data.coachData);
      });
    },
    //获取未完课列表数据
    getBeginCourseList() {
      const para = Object.assign(
        {},
        this.courseData,
        this.beginCourseSearchData
      );
      getFinishedCourseLists(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.courseData;
        // this.courseTypeData = res.data.data.courseTypeData;
        // this.courseLocationData = res.data.data.courseLocationData;
        // this.format_course_type_list = res.data.data.formatCourseTypeList;
        // this.format_course_location_list =
        //   res.data.data.formatCourseLocationList;
      });
    },
    // // 显示资金弹框
    // showAddCourseDialog(val) {
    //   this.$store.commit("SET_COURSE_DIALOG_TITLE", val);
    //   this.addCourseDialog.show = true;
    // },
    // hideAddFundDialog() {
    //   this.addCourseDialog.show = false;
    // },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getBeginCourseList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getBeginCourseList();
    },
    onEditFinishedCourse(row) {
      let data = {
        id: row.id,
        courseNote: row.courseNote,
      };
      this.courseData.courseDate = row.courseDate;
      this.courseData.courseTime = row.courseTime;
      this.courseData.courseLocation = this.format_course_location_list[
        parseInt(row.courseLocation)
      ];
      this.courseData.courseType = this.format_course_type_list[
        parseInt(row.classType)
      ];
      this.form = data;
      this.clockInDialogShow = true;
    },
    onEditCoach(row) {
      // console.log("row:", row);
      const para = { courseId: row.id };
      getCoachListsByCourseId(para).then((res) => {
        // console.log(res.data.data.coaches);

        var coachIdVar = [];
        var caches = res.data.data.coaches;
        console.log(caches);
        if (caches !== null && caches !== "" && caches !== "undefined") {
          res.data.data.coaches.split(",").forEach(function (data, index, arr) {
            coachIdVar.push(+data);
          });
          this.coachform.coachId = coachIdVar;
        } else {
          this.coachform.coachId = [];
        }
      });
      this.courseData.courseDate = row.courseDate;
      this.courseData.courseTime = row.courseTime;
      this.courseData.courseLocation = this.format_course_location_list[
        parseInt(row.courseLocation)
      ];
      this.courseData.courseType = this.format_course_type_list[
        parseInt(row.classType)
      ];
      console.log(this.coachform.coachId);
      this.course_id = row.id;
      this.clockInDialogShow1 = true;
    },
    onSubmit1(form) {
      let formData = this[form];
      var coachIdStr = "";
      formData.coachId.forEach((value) => {
        coachIdStr = coachIdStr + value + ",";
      });
      const para = { courseId: this.course_id, coachId: coachIdStr };
      console.log(para);
      courseBlindCoach(para).then((res) => {
        console.log(res);
        this.clockInDialogShow1 = false;
        var content =
          "课程教练打卡，课程日期:" +
          this.courseData.courseDate +
          ",时间段为:" +
          this.courseData.courseTime +
          "课程地点:" +
          this.courseData.courseLocation +
          ",班级类型为:" +
          this.courseData.courseType;
        const para = {
          userName: getToken("USERNAME"),
          content: content,
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
        this.getBeginCourseList();
      });
    },
    onSubmit(form) {
      let formData = this[form];
      editFinishedCourse(formData).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "info",
            message: "修改备注成功",
            duration: 3000,
          });
          this.clockInDialogShow = false;
          var content =
            "修改完课课程操作,课程日期" +
            this.courseData.courseDate +
            ",时间段为:" +
            this.courseData.courseTime +
            "课程地点:" +
            this.courseData.courseLocation +
            ",班级类型为:" +
            this.courseData.courseType;
          const para = {
            userName: getToken("USERNAME"),
            content: content,
          };
          addOperationRecord(para).then((res) => {
            console.log(res);
          });
          this.getBeginCourseList();
        } else if (res.data.code == 201) {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 3000,
          });
        }
      });
    },
    //跳转课程详情页
    onGoToDetail(row) {
      let id = {
        courseId: row.id,
      };
      getCoursePackagesByCourseId(id).then((res) => {
        console.log(res);
        let para = {
          id: row.id,
          courseDate: formatDateTime(row.courseDate),
          courseTime: row.courseTime,
          courseType: this.formatterCourseType(row),
          courseLocation: this.formatterCourseLocation(row),
          courseCoachList: row.coaches,
          coursePackages: res.data.data.coursePackages,
        };
        this.$store.commit("SET_COURSE_DETAILS", para);
        this.$router.push({ path: "/courseManage/courseDetails" });
      });
      // getCourseCoachLists(id).then((res) => {
      //   console.log(res);
      //   let para = {
      //     id: row.id,
      //     courseDate: formatDateTime(row.courseDate),
      //     courseTime: row.courseTime,
      //     courseType: this.formatterCourseType(row),
      //     courseLocation: this.formatterCourseLocation(row),
      //     courseCoachList: res.data.data.courseCoachList,
      //     coursePackages: row.coursePackages,
      //   };
      //   this.$store.commit("SET_COURSE_DETAILS", para);
      //   this.$router.push({ path: "/courseManage/courseDetails" });
      // });
    },
    /**
     * 格式化状态
     */
    filterCourseType(value, item) {
      const type = parseInt(item.classType);
      return (
        this.format_course_type_list[value] ==
        this.format_course_type_list[type]
      );
    },
    filterCourseLocation(value, item) {
      const type = parseInt(item.courseLocation);
      return (
        this.format_course_location_list[value] ==
        this.format_course_location_list[type]
      );
    },
    filterCoursePackages(value, item) {
      const type = parseInt(item.coursePackages);
      return (
        this.format_course_packages_list[value] ==
        this.format_course_packages_list[type]
      );
    },
    formatterCourseType(item) {
      const type = parseInt(item.classType);
      return this.format_course_type_list[type];
    },
    formatterCourseLocation(item) {
      const type = parseInt(item.courseLocation);
      return this.format_course_location_list[type];
    },
    formatterCoursePackages(item) {
      const type = parseInt(item.coursePackages);
      return this.format_course_packages_list[type];
    },
    // // 编辑操作方法
    // onEditCourse(row) {
    //   var courseTime = row.courseTime;
    //   var courseTimeArray = courseTime.split("-");
    //   var para = {
    //     beginTime: courseTimeArray[0],
    //     endTime: courseTimeArray[1]
    //   };
    //   var param = Object.assign({}, row, para);
    //   console.log(param);
    //   this.addCourseDialog.dialogRow = {
    //     param
    //   };
    //   this.showAddCourseDialog();
    // },
    // // 删除数据
    // onDeleteCourse(row) {
    //   this.$confirm("确认删除该记录吗?", "提示", {
    //     type: "warning"
    //   })
    //     .then(() => {
    //       const para = { id: row.id };
    //       deleteUnBeginCourse(para).then(res => {
    //         this.$message({
    //           message: "删除成功",
    //           type: "success"
    //         });
    //         this.getBeginCourseList();
    //       });
    //     })
    //     .catch(() => {});
    // },
    // onBatchDelMember() {
    //   this.$confirm("确认批量删除记录吗?", "提示", {
    //     type: "warning"
    //   })
    //     .then(() => {
    //       const ids = this.multipleSelection.map(item => item.id).toString();
    //       const para = { ids: ids };
    //       batchDeleteUnBeginCourse(para).then(res => {
    //         // console.log(res);
    //         if (res.data.code == 200) {
    //           this.$message({
    //             message: "批量删除成功",
    //             type: "success"
    //           });
    //           this.getBeginCourseList();
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    toggleRowData(row, expandedRows) {
      if (expandedRows.length) {
        this.expands = []
        if(row) {
          this.getCourseStudentInfo(row.id)
          this.currentExpandRow = row
        }
      } else {
         this.expands = []
         this.currentExpandRow = {}
      }
    },
    getCourseStudentInfo(id) {
      getCourseByMemberLists({id:id}).then(res => {
        console.log(res.data.data.recordData);
        this.expandsStudent = res.data.data.recordData
        this.expands.push(id)
      })
    },
    //添加学生模态框
    onOpenAddStudent(row) {
      console.log('添加学生，当前课程行',row);
      this.courseRow = row
      this.appointmentVisible = true
    },
    submitStudent() {
      this.appointmentVisible = false
      this.appointmentData.courseId = this.courseRow.id
      console.log('上传学生',this.appointmentData);
      addAppointmentCourseByPhone(this.appointmentData).then((res) => {
        console.log(res,5145);
        if(res.data.code === 200) {
          this.$message({
            message: '添加成功',
            type: "success",
          });
        }else {
          this.$message({
            message: res.data.data,
            type: "error",
          });
        }
        const para = {
          userName: getToken("USERNAME"),
          content:  `增加${this.courseRow.courseDate.split(' ')[0]} ${this.courseRow.courseTime}，学生：${this.appointmentData.studentName}`
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
        this.expands = []
        this.currentExpandRow = {}
        this.getBeginCourseList();
      });
    },
    delAppointment(row) {
      this.clockInDialogShow9 = true;
      this.courseRow = row
      console.log(row)
    },
    //删除学生
    onDelAppointment() {
      this.appointmentRecordDate.id = this.courseRow.id
      deleteRecord(this.appointmentRecordDate).then((res) => {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        const para = {
          userName: getToken("USERNAME"),
          content:  `删除${this.currentExpandRow.courseDate.split(' ')[0]}，课程时间段${this.currentExpandRow.courseTime}的学生${this.courseRow.stdName}`
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
        this.expands = []
        this.currentExpandRow = {}
        this.getBeginCourseList();
        this.clockInDialogShow9 = false
      });

    },
    //删除学生
    onStudentDel(row) {
      console.log('删除学生，当前学生行',row);
      this.$confirm("是否删除该学生?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteRecord({id: row.id}).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:  `删除${this.currentExpandRow.courseDate.split(' ')[0]}，课程时间段${this.currentExpandRow.courseTime}的学生${row.stdName}`
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.expands = []
            this.currentExpandRow = {}
            this.getBeginCourseList();
          });
        })
        .catch(() => {});
    },
    //编辑学生模态框打开
    onStudentEdit(row) {
      this.studentData = row
      this.studentVisible = true
    },
    //提交编辑学生
    eidtStudent() {
      updateRecord(this.studentData).then(res => {
        this.$message.success('编辑成功')
        this.studentVisible = false
        this.getBeginCourseList();
      })
    },
    //监听手机号
    searchCourse(phone) {
      clearTimeout(this.phoneTimer)
      this.phoneTimer = setTimeout(() => {
        if(phone.length === 11) {
          this.getCourseData(phone)

        }
      }, 400);
    },
    getCourseData(phone) {
      getCoursePackageAndMemberByPhone({phone}).then(res => {
        if(res.data.data.coursePackageAndMemberDatas !== undefined) {
          this.coursePackageAndMemberOption = res.data.data.coursePackageAndMemberDatas
          if(this.coursePackageAndMemberOption.length === 0) {
            this.coursePackageAndMemberOption = [
              {
                value: "-1",
                label: "该会员没有这种类型的课包",
              },
            ]
            this.$message.error('当前会员没有课包')
          }
        }else {
          this.coursePackageAndMemberOption = []
          this.appointmentData.coursepackageid = ""
          this.$message.error('会员不存在')
        }
      })
    },
    //删除记录弹框部分
    onOpenDeleteRecord(row) {
      this.deleteRecordRow = row
      this.deleteRecordVisible = true
      this.deleteRecordForm = this.$options.data().deleteRecordForm
      this.getDeleteRecordList()
    },
    handleCurrentChangeDelete(val) {
      this.deleteRecordForm.page = val;
      this.getDeleteRecordList()
    },
    handleSizeChangeDelete(val) {
      this.deleteRecordForm.limit = val;
      this.getDeleteRecordList()
    },
    getDeleteRecordList() {
      getCourseExtByMemberLists({id: this.deleteRecordRow.id, ...this.deleteRecordForm}).then(res => {
        console.log(res,789); 
        this.pageTotalDelete = res.data.data.total;
        this.deleteRecordList = res.data.data.recordData;
      })
    },
    // setSearchBtn(val) {
    //   let isFlag = true;
    //   if (val.length > 0) {
    //     isFlag = false;
    //   } else {
    //     isFlag = true;
    //   }
    //   this.$store.commit("SET_SEARCHBTN_DISABLED", isFlag);
    // }
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>
